import { Form } from "react-bootstrap";

const PAGE_SIZE_OPTIONS = [5, 10, 25, 50];

interface FeatureFlagListToolbarProps {
  pageSize: number;
  searchValue: string;
  onPageSizeChange: (pageSize: number) => void;
  onSearchChange: (value: string) => void;
}

/** Renders page-size and search controls above the feature flag table. */
function FeatureFlagListToolbar({
  pageSize,
  searchValue,
  onPageSizeChange,
  onSearchChange,
}: FeatureFlagListToolbarProps) {
  return (
    <div className="featureFlagListToolbar">
      <div className="pageSizeControl">
        <span>Show </span>
        <Form.Control
          as="select"
          size="sm"
          className="pageSizeSelect"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          aria-label="Rows per page"
        >
          {PAGE_SIZE_OPTIONS.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </Form.Control>
        <span> entries</span>
      </div>
      <div className="searchControl">
        <label htmlFor="featureFlagSearch" className="mb-0 mr-2">
          Search:
        </label>
        <Form.Control
          id="featureFlagSearch"
          type="search"
          size="sm"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          aria-label="Search feature flags by name or description"
        />
      </div>
    </div>
  );
}

export default FeatureFlagListToolbar;
